import moment from "moment";
import { displayDateFormat } from "../../../utils/helpers";

export const l1Columns = ({ tableData, extraColumns = [] }) => [
  ...extraColumns,
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (props) => {
      if (!props?.row?.original?.submittedOn) {
        return "-";
      }
      return (
        <div>
          {moment(
            props?.row?.original?.submittedOn).format(displayDateFormat)}
          {/* {props?.row?.original?.submittedOn || ""} */}
        </div>
      );
    },
  },
  {
    Header: "Amount (₹)",
    accessor: "rejectedAmount",
    Cell: (props) => {
      const value = props?.row?.original?.rejectedAmount;
      if (!value) {
        return "-";
      }
      return <div className={"text-[var(--textRed)]"}>{value ? Number(value).toFixed(2) : "-"}</div>;
    },
  },

  {
    Header: "Status",
    accessor: "rejected",
    Cell: () => {
      return <div className={"text-[var(--textRed)]"}>Rejected</div>;
    },
  },
  // {
  //   Header: "Rejected",
  //   accessor: "rejectedAmount",
  //   Cell: (props) => {
  //     const value = props?.row?.original?.rejectedAmount;
  //     if (!value) {
  //       return "-";
  //     }
  //     return <div className={"text-[var(--textRed)]"}>{value}</div>;
  //   },
  // },
];
